import ListErrors from './ListErrors'
import React from 'react'
import agent from '../agent'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom';
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'
import Loading from './widgets/Loading'
import {
  COIN_SEND_LOADED,
  UPDATE_FIELD_AUTH,
  COIN_SEND,
  COIN_SEND_UNLOADED,
  UPDATE_FIELD_SEND
} from '../constants/actionTypes'
import { COIN_MASTER_ADDRESS } from '../constants/config'
import Util from '../util/util'
const mapStateToProps = state => (
  {
    ...state.coins,
    inProgress: state.common.inProgress
  })

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: COIN_SEND_LOADED, payload })
  },
  onChangeSender: value =>
    dispatch({ type: UPDATE_FIELD_SEND, key: 'sender', value }),
  onChangeRecipient: value =>
    dispatch({ type: UPDATE_FIELD_SEND, key: 'recipient_address', value }),
  onChangeAmount: value =>
    dispatch({ type: UPDATE_FIELD_SEND, key: 'amount', value }),
  onChangeNotes: value =>
    dispatch({ type: UPDATE_FIELD_SEND, key: 'notes', value }),
  onChangePin: value =>
    dispatch({ type: UPDATE_FIELD_SEND, key: 'pin', value }),
  onSubmit: (payload) =>
    dispatch({ type: COIN_SEND, payload }),
  onUnload: () =>
    dispatch({ type: COIN_SEND_UNLOADED })
})

class CoinSend extends React.Component {
  constructor() {
    super()
    this.state = {
      success_message: '',
      sender_address: '',
      sender_key: '',
      displayCodePin: false,
    }
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    }
    this.onSelectAccounts = this.onSelectAccounts.bind(this)
    this.changeSender = ev => this.props.onChangeSender(ev.target.value)
    this.changeRecipient = ev => this.props.onChangeRecipient(ev.target.value)
    this.changeAmount = ev => this.props.onChangeAmount(ev.target.value)
    this.changeNotes = ev => this.props.onChangeNotes(ev.target.value)
    this.changePin = ev => this.props.onChangePin(ev.target.value)

    this.submitForm = (sender_address, recipient_address, amount, notes, pin, code) => ev => {
      ev.preventDefault()
      this.setState({ success_message: '' })
      const payload = agent.Coins.sendViaAddress(sender_address, recipient_address, amount, notes, pin, code)
      this.props.onSubmit(payload)
    }
  }
  onSelectAccounts(option) {
    this.setState({ sender_address: option.value })
  }
  componentWillMount() {
    let search = this.props.location.search
    if (search) {
      let args = Util.getQueryStringArgs(search.toLowerCase())
      // console.log(args)
      if (args) {
        if (args.address) {
          this.setState({ sender_address: args.address })
        }
        if (args.key) {
          this.setState({ sender_key: args.key })
        }
      }
    }

    const payload = agent.Accounts.getMasterAccounts()
    this.props.onLoad(payload);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.send_success) {
      this.setState({ success_message: 'Send success', displayCodePin: false })
    } else if (nextProps.codeStatus === 'sent') {
      this.setState({ displayCodePin: true })
    }
  }
  componentWillUnmount() {
    this.props.onUnload()
  }

  render() {
    if (!this.props.accounts) {
      return (
        <Loading />
      )
    }
    // const sender = this.props.sender
    const recipient_address = this.props.recipient_address
    const amount = this.props.amount
    const notes = this.props.notes || ''
    const accounts = this.props.accounts
    const symbolOptions = accounts.map(i => { return { value: i.external, label: i.symbol } })

    const sender_address = this.state.sender_address || symbolOptions[0].value
    const code = this.state.code
    const pin = this.props.pin
    const sender_key = this.state.sender_key
    const back_url = sender_key ? `/masteraccounts/${sender_key}/detail` : `/coins`
    return (
      <div class='pane'>
        <Link className="crumb" to={back_url}>&laquo; back</Link>
        <h1>Send Coins</h1>
        <ListErrors errors={this.props.errors} />
        <div className="form-group">
          {this.state.success_message}
        </div>
        {!this.state.displayCodePin ? (
          <form onSubmit={this.submitForm(sender_address, recipient_address, amount, notes, pin, null)}>
            <fieldset className="form">
              <fieldset className="form-group">
                <div style={{ maxWidth: '300px' }}><Dropdown options={symbolOptions} onChange={this.onSelectAccounts} value={sender_address} /></div>
              </fieldset>
              <fieldset className="form-group">
                <input
                  type="text"
                  placeholder="recipient address"
                  value={recipient_address}
                  onChange={this.changeRecipient} />
              </fieldset>
              <fieldset className="form-group">
                <input
                  type="text"
                  placeholder="amount"
                  value={amount}
                  onChange={this.changeAmount} />
              </fieldset>
              <fieldset className="form-group">
                <input
                  type="text"
                  placeholder="notes"
                  value={notes}
                  onChange={this.changeNotes} />
              </fieldset>
              <fieldset className="form-group">
                <input
                  type="password"
                  placeholder="Pin code"
                  value={pin}
                  maxLength={4}
                  onChange={this.changePin} />
              </fieldset>
              <fieldset className="form-group">
                <button
                  type="submit"
                  disabled={this.props.inProgress}>
                  {this.props.inProgress ? 'Sending...' : 'Send'}
                </button>
              </fieldset>
            </fieldset>
          </form>
        ) : (
            <div>
              <fieldset className="form">
                <div className="form-group">
                  <div className={'form-label'}>Verification Code</div>
                  <input
                    type="text"
                    value={code}
                    onChange={this.updateState('code')} />
                </div>
                <ListErrors errors={this.props.errors} />
                <button
                  onClick={this.submitForm(sender_address, recipient_address, amount, notes, pin, code)}
                  disabled={this.props.inProgress}>
                  {this.props.inProgress ? 'Sending...' : 'Send'}
                </button>

              </fieldset>
            </div>
          )
        }
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CoinSend)



// WEBPACK FOOTER //
// ./src/components/CoinSend.js